import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contextauth/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  // Si l'état de l'utilisateur est en cours de chargement, ne rien afficher pour l'instant
  if (loading) {
    return <div>Chargement...</div>;
  }

  // Si l'utilisateur n'est pas connecté ou n'est pas un admin, rediriger
  if (!user || user.role !== 'admin') {
    return <Navigate to="/" />;  // Redirige vers la page d'accueil si l'utilisateur n'est pas admin
  }

  return children;  // Si l'utilisateur est admin, afficher le contenu
};

export default PrivateRoute;
